import { IClient, IDeliveryAddress } from 'client/IClientInfo'
import { reqGet, reqPost, TOneItemCallback, TStatusCallbak } from 'HttpRequests'

function reqGetClientInfo(callbak: (clientInfo: IClient) => void) {
  reqGet('api/get_client_info/', callbak)
}

function reqUpdateClientInfo(params: any, callback: TOneItemCallback<IClient>) {
  reqPost('api/update_client_info/', { params }, callback)
}

function reqUpdateClientParam(
  parameterKey: string,
  value: string | number,
  callbak: TStatusCallbak
) {
  reqPost('api/update_client_info_parameter/', { parameterKey, value }, callbak)
}

function reqSendChangePasswordCode(callback: TStatusCallbak) {
  reqGet('api/send_change_password_code/', callback)
}

function reqChangeClientPassword(
  oldPassword: string,
  code: number,
  newPassword: string,
  newPasswordSecond: string,
  callback: (respnse: { status: string; client: IClient }) => void
) {
  reqPost(
    'api/change_client_password/',
    { oldPassword, code, newPassword, newPasswordSecond },
    callback
  )
}

function reqAddDeliveryAddress(
  address: IDeliveryAddress,
  callback: TOneItemCallback<IDeliveryAddress | null>
) {
  reqPost('api/add_delivery_address/', { addressParameters: address }, callback)
}

function reqUpdateDeliveryAddress(
  address: IDeliveryAddress,
  callback: TOneItemCallback<IDeliveryAddress | null>
) {
  reqPost(
    'api/update_delivery_address/',
    { addressId: address.deliv_addr_id, addressParameters: address },
    callback
  )
}

function reqRemoveDeliveryAddress(addressId: number, callback: TStatusCallbak) {
  reqGet('api/remove_delivery_address/' + addressId, callback)
}

export {
  reqUpdateClientInfo,
  reqUpdateClientParam,
  reqGetClientInfo,
  reqSendChangePasswordCode,
  reqChangeClientPassword,
  reqAddDeliveryAddress,
  reqUpdateDeliveryAddress,
  reqRemoveDeliveryAddress,
}
